import axios from "axios";
import {useTokensStore} from "@/composables/tokens";

const tokensStore = useTokensStore();

// @ts-ignore
const baseURL = process.env.API_URL;
const http = axios.create({
    baseURL,
});

// @ts-ignore
const env = process.env.NODE_ENV;

http.interceptors.request.use(
    (config) => {
        if (env === 'development') {
            config.headers.Authorization = 'tma user=%7B%22id%22%3A7073522%2C%22first_name%22%3A%22%D0%A1%D1%82%D0%B5%D0%BF%D0%B0%D0%BD%22%2C%22last_name%22%3A%22%D0%93%D1%83%D0%B1%D0%B8%D0%BD%22%2C%22username%22%3Anull%2C%22language_code%22%3A%22ru%22%2C%22photo_url%22%3A%22https%3A%2F%2Fi.oneme.ru%2Fi%3Fr%3DBTGBPUwtwgYUeoFhO7rESmr8zwrhZ_p4jWvgWajP77Kf1a895I6GFz6-d8pGAUlO8BI%22%7D&ip=95.190.195.2&chat=%7B%22id%22%3A196969818%2C%22type%22%3A%22DIALOG%22%7D&hash=f4cd018218a7e8275c23b2defde545691ac2b38a6c3ab72772130cf2a7a4b699&auth_date=1775578418&query_id=324c1e35-f08b-42dd-874f-0c6f9de96688';
        } else {
            config.headers.Authorization = `tma ${window.WebApp.initData}`;
        }

        // @ts-ignore
        const url = new URL(config.baseURL + config.url);

        const token = tokensStore.getToken();
        if (token)
            url.searchParams.set('token', token);

        // Устанавливаем URL обратно
        config.url = url.toString();

        return config;
    },
);

export default http;